import axios from 'axios'
import qs from 'qs'

//let  baseURL = 'http://192.168.31.157:8901/dev/wx'
// let baseURL = 'http://test.aidocoin.net/wx'
let baseURL = 'https://open.aidocoin.net/wx'

// create an axios instance
const service = axios.create({
  baseURL: baseURL, // 获取配置文件
  withCredentials: true, // send cookies when cross-domain requests
  timeout:300000 // request timeout
})

// request拦截器
service.interceptors.request.use(
  config => {
    // 当请求方式为post的时候，参数需要qs序列化
    if (config.method === 'post') {
      config.data = qs.stringify(config.data);
    } 
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response拦截器
service.interceptors.response.use(
  response => {
    const code = Number(response.data.code);
    if (code === 0 || code === 200) {
      return response.data;
    } else {
      // 接口失败处理
      switch (code) {
        case 401:
        break;
        default:
          return Promise.reject(response.data || 'error');
      }
    }
  },
  error => {
	 alert(error)
    return Promise.reject(error)
  }
)

export default service;  